import { configureStore } from '@reduxjs/toolkit';

import categoriesAPI from "../services/categories-api";
import uploadAPI from 'src/services/upload-query';
import downloadAPI from 'src/services/download-query';
import customerAPI from 'src/services/customer-query';
import productAPI from 'src/services/product-query';
import damageAPI from 'src/services/damage-query';
import packagesAPI from 'src/services/packages-query';
import configAPI from 'src/services/config-query';
import staffAPI from 'src/services/staff-query';
import deliveryPersonAPI from 'src/services/delivery-person-query';
import creditAPI from 'src/services/credit-query';
import regionAPI from 'src/services/region-query';
import expiryAPI from 'src/services/expiry-query';
import ordersAPI from 'src/services/order-query';
import reviewsAPI from 'src/services/review-query';
import supportAPI from 'src/services/support-query';
import productGroupAPI from 'src/services/product-group-query';
import notificationAPI from 'src/services/notification-query';
import quickBookAPI from 'src/services/quick-book-query';

export const store = configureStore({
  reducer: {
    [customerAPI.reducerPath]: customerAPI.reducer,
    [downloadAPI.reducerPath]: downloadAPI.reducer,
    [uploadAPI.reducerPath]: uploadAPI.reducer,
    [categoriesAPI.reducerPath]: categoriesAPI.reducer,
    [productAPI.reducerPath]: productAPI.reducer,
    [damageAPI.reducerPath]: damageAPI.reducer,
    [packagesAPI.reducerPath]: packagesAPI.reducer,
    [configAPI.reducerPath]: configAPI.reducer,
    [staffAPI.reducerPath]: staffAPI.reducer,
    [deliveryPersonAPI.reducerPath]: deliveryPersonAPI.reducer,
    [creditAPI.reducerPath]: creditAPI.reducer,
    [regionAPI.reducerPath]: regionAPI.reducer,
    [expiryAPI.reducerPath]: expiryAPI.reducer,
    [ordersAPI.reducerPath]: ordersAPI.reducer,
    [reviewsAPI.reducerPath]: reviewsAPI.reducer,
    [supportAPI.reducerPath]: supportAPI.reducer,
    [productGroupAPI.reducerPath]: productGroupAPI.reducer,
    [notificationAPI.reducerPath]: notificationAPI.reducer,
    [quickBookAPI.reducerPath]: quickBookAPI.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(customerAPI.middleware)
    .concat(downloadAPI.middleware)
    .concat(uploadAPI.middleware)
    .concat(categoriesAPI.middleware)
    .concat(productAPI.middleware)
    .concat(damageAPI.middleware)
    .concat(packagesAPI.middleware)
    .concat(configAPI.middleware)
    .concat(staffAPI.middleware)
    .concat(deliveryPersonAPI.middleware)
    .concat(creditAPI.middleware)
    .concat(regionAPI.middleware)
    .concat(expiryAPI.middleware)
    .concat(ordersAPI.middleware)
    .concat(reviewsAPI.middleware)
    .concat(supportAPI.middleware)
    .concat(productGroupAPI.middleware)
    .concat(notificationAPI.middleware)
    .concat(quickBookAPI.middleware)
})